import { useCacheDataFlag } from './hooks';
const CacheHandler = () => {
    useCacheDataFlag();
    return null;
};
export default CacheHandler;
